import React from "react";
import { Details, Portfolio, Row } from "../components";
import { HOME_PAGE } from "..";

export interface IWork {
  id: string;
  title: string;
  image: string;
  description: string;
  period: string;
  tech: string;
  role: string;
  link: string;
  linkText: string;
}

interface IProps {
  work: IWork;
}

const WorkContainer: React.FC<IProps> = ({ work }) => (
  <Portfolio.Item key={work.id}>
    <Portfolio.Thumbnail>
      <Portfolio.Image
        src={`${HOME_PAGE}${work.image}`}
        alt='portfolio item thumb'
      />
    </Portfolio.Thumbnail>
    <Portfolio.Title>{work.title}</Portfolio.Title>
    <Portfolio.Details>
      <Portfolio.Button>view project</Portfolio.Button>
      <Portfolio.Content src={`${HOME_PAGE}${work.image}`} title={work.title}>
        <Details>
          <Details.Description>
            <Details.Text>{work.description}</Details.Text>
          </Details.Description>
          <Details.Container>
            <Details.Infos>
              <Details.Info>
                Created - <Details.InnerInfo>{work.period}</Details.InnerInfo>
              </Details.Info>
              <Details.Info>
                Technologies used -{" "}
                <Details.InnerInfo>{work.tech}</Details.InnerInfo>
              </Details.Info>
              <Details.Info>
                Role - <Details.InnerInfo>{work.role}</Details.InnerInfo>
              </Details.Info>
              <Details.Info>
                View Online -{" "}
                <Details.InnerInfo>
                  <a href={work.link}>{work.linkText}</a>
                </Details.InnerInfo>
              </Details.Info>
            </Details.Infos>
          </Details.Container>
        </Details>
      </Portfolio.Content>
    </Portfolio.Details>
  </Portfolio.Item>
);

export default WorkContainer;
